import { Order, PlanCar, PlanDest } from '@/types/plan';
import { BasicInfo, Car, Dest, DestDetail, ShippingDetail, TimeLine } from '@/types/result';
import { atom } from 'jotai';
import { atomWithReset } from 'jotai/utils';

export const DEFAULT_ZOOM = 9;
export const MARKER_VIEW_ZOOM = 9;

export const backdropAtom = atomWithReset<boolean>(true);
export const backdropTextAtom = atomWithReset<string>('');

export const shippingListCollapseAtom = atomWithReset<boolean>(true);

export const basicInfoAtom = atomWithReset<BasicInfo>(undefined);

export const shippingListAtom = atomWithReset<ShippingDetail[]>([]);

export const selectedCarListAtom = atomWithReset<number[]>([]);

export const mapCenterCoorAtom = atomWithReset<naver.maps.Coord>(undefined);

export const mapZoomLevelAtom = atomWithReset<number>(DEFAULT_ZOOM);

export const destDetailAtom = atomWithReset<DestDetail>(undefined);

export const shippingCardOverAtom = atomWithReset<number>(undefined);

export const polyLineOverAtom = atomWithReset<number>(undefined);

export const timeLineAtom = atomWithReset<boolean>(false);

export const timeLineOrgArrAtom = atomWithReset<TimeLine[]>([]);
export const timeLineChgArrAtom = atomWithReset<TimeLine[]>([]);
export const resultDestListAtom = atomWithReset<any[]>([]);

export const changeCarListAtom = atomWithReset<number[]>([]);

export const reRouteListAtom = atomWithReset<any[]>([]);

export const allDestListModalAtom = atomWithReset<boolean>(false);
export const allCarListModalAtom = atomWithReset<boolean>(false);
export const allOrderListModalAtom = atomWithReset<boolean>(false);
export const allNotAssignListModalAtom = atomWithReset<boolean>(false);

//PLAN ATOM
//PLAN MODAL
export const selectOrderModalAtom = atomWithReset<boolean>(false);
export const destInfoModalAtom = atomWithReset<boolean>(false);
export const selectCarModalAtom = atomWithReset<boolean>(false);
export const carInfoModalAtom = atomWithReset<boolean>(false);

export const planRegistConfirmAtom = atomWithReset<boolean>(false);

export const selectedCenterAtom = atomWithReset<number>(undefined);

export const selectedOrderListAtom = atomWithReset<Order[] | PlanDest[]>([]);
export const selectedPlanCarListAtom = atomWithReset<PlanCar[]>([]);

export const planDestListAtom = atomWithReset<PlanDest[]>([]);
export const planCarListAtom = atomWithReset<PlanCar[]>([]);

export const targetShippingSeqAtom = atomWithReset<number>(undefined);
export const shippingMainModalAtom = atomWithReset<boolean>(false);

export const shippingCompleteAtom = atomWithReset<boolean>(false);

export const SHIPPING_TYPE: any = {
  0: '최소차량',
  1: '모든차량',
  2: '최소차량',
  3: '모든차량',
};
